import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

const Comingsoon = () => {
  useEffect(() => {
    // Create particles
    const particleCount = 50;
    const particles = [];
    
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        id: i,
        posX: Math.random() * 100,
        posY: Math.random() * 100,
        size: Math.random() * 3 + 1,
        duration: Math.random() * 30 + 10,
        delay: Math.random() * 5
      });
    }
    
    setParticleElements(particles);
    
    // Add mousemove event listener for 3D effects
    const handleMouseMove = (e) => {
      const mouseX = e.clientX / window.innerWidth - 0.5;
      const mouseY = e.clientY / window.innerHeight - 0.5;
      
      setMousePosition({ x: mouseX, y: mouseY });
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    
    // Cleanup
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  
  const [particleElements, setParticleElements] = useState([]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  // Direct Image URL - replace this with your actual logo URL
  const logoUrl = process.env.PUBLIC_URL + '/logo_white.png';
  
  const handleNotifyClick = async () => {
    // alert('Thank you! We will notify you when Alchemy Markets launches.');
    const result = await Swal.fire({
        title: "",
        html: `Yay!! We will be coming soon! <br><br><strong>Till then you can enjoy our application "Alchemy Markets" from Stores.</strong>`,
        imageUrl: process.env.PUBLIC_URL + '/logo.png',
        imageSize: '80x80',
        showConfirmButton: false,
        showCancelButton: false,
        timer: 5000,
        timerProgressBar: true,
        didClose: () => {}
    });
  };
  
  // Style objects
  const styles = {
    body: {
      fontFamily: "'Montserrat', sans-serif",
      backgroundColor: "#1c1a15",
      color: "#e0dbc7",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      overflow: "hidden",
      perspective: "1000px",
      margin: 0,
      padding: 0
    },
    container: {
      textAlign: "center",
      zIndex: 10,
      padding: "20px",
      transform: `translateX(${mousePosition.x * 15}px) translateY(${mousePosition.y * 15}px)`
    },
    logo: {
      width: "180px",
      height: "180px",
      margin: "0 auto 40px",
      position: "relative",
      transformStyle: "preserve-3d",
      animation: "logoEntrance 1.5s ease-out forwards"
    },
    logoWrapper: {
      position: "relative",
      width: "100%",
      height: "100%",
      transformStyle: "preserve-3d",
      animation: "float 6s infinite ease-in-out",
      transform: `rotateY(${mousePosition.x * 20}deg) rotateX(${-mousePosition.y * 20}deg) translateY(-15px)`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    logoImage: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
      borderRadius: "15px",
      animation: "pulse 4s infinite ease-in-out"
    },
    heading: {
      fontSize: "3.5rem",
      fontWeight: 700,
      marginBottom: "20px",
      letterSpacing: "6px",
      opacity: 0,
      animation: "textReveal 0.5s ease-out forwards",
      animationDelay: "1.2s",
      position: "relative",
      textShadow: "0 5px 15px rgba(0,0,0,0.3)"
    },
    headingSpan: (index) => ({
      display: "inline-block",
      animation: "letterFloat 2s infinite ease-in-out",
      animationDelay: `${index * 0.1}s`
    }),
    paragraph: {
      fontSize: "1.4rem",
      fontWeight: 400,
      marginBottom: "40px",
      opacity: 0,
      animation: "fadeInUp 0.8s ease-out forwards",
      animationDelay: "1.8s",
      position: "relative"
    },
    notifyBtn: {
      display: "inline-block",
      padding: "12px 28px",
      background: "linear-gradient(45deg, #2c2a25, #413e34)",
      color: "#e0dbc7",
      border: "none",
      borderRadius: "30px",
      fontSize: "1rem",
      fontWeight: 600,
      cursor: "pointer",
      position: "relative",
      overflow: "hidden",
      transition: "all 0.3s ease",
      boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
      opacity: 0,
      animation: "fadeInUp 0.8s ease-out forwards",
      animationDelay: "2.2s"
    },
    notifyBtnHover: {
      transform: "translateY(-5px)",
      boxShadow: "0 10px 25px rgba(0,0,0,0.3)"
    },
    notifyBtnBefore: {
      content: "''",
      position: "absolute",
      top: "-50%",
      left: "-50%",
      width: "200%",
      height: "200%",
      background: "linear-gradient(45deg, transparent, rgba(224, 219, 199, 0.3), transparent)",
      transform: "rotate(45deg)",
      animation: "btnShine 3s infinite linear"
    },
    orb: (index, delay) => ({
      position: "absolute",
      borderRadius: "50%",
      filter: "blur(60px)",
      zIndex: 1,
      opacity: 0,
      animation: `orbReveal 1s ease-out ${delay}s forwards, orbFloat 15s infinite ease-in-out ${index * -5}s`,
      transform: `translate(${mousePosition.x * (15 - index * 3)}px, ${mousePosition.y * (15 - index * 3)}px)`
    }),
    orb1: {
      width: "300px",
      height: "300px",
      top: "-100px",
      left: "15%",
      backgroundColor: "rgba(161, 140, 86, 0.3)"
    },
    orb2: {
      width: "400px",
      height: "400px",
      bottom: "-150px",
      right: "15%",
      backgroundColor: "rgba(112, 128, 144, 0.2)"
    },
    orb3: {
      width: "200px",
      height: "200px",
      bottom: "20%",
      left: "10%",
      backgroundColor: "rgba(205, 175, 112, 0.25)"
    },
    orb4: {
      width: "150px",
      height: "150px",
      top: "20%",
      right: "10%",
      backgroundColor: "rgba(157, 142, 93, 0.3)"
    },
    particles: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 0
    },
    particle: (particle) => ({
      position: "absolute",
      width: `${particle.size}px`,
      height: `${particle.size}px`,
      backgroundColor: "rgba(224, 219, 199, 0.5)",
      borderRadius: "50%",
      left: `${particle.posX}%`,
      top: `${particle.posY}%`,
      animation: `particleFloat ${particle.duration}s infinite linear ${particle.delay}s`
    })
  };

  // Animation keyframes as a string to be included in the component
  const keyframes = `
    @keyframes logoEntrance {
      0% { 
        opacity: 0;
        transform: translateY(-100px) rotateX(45deg);
      }
      100% { 
        opacity: 1;
        transform: translateY(0) rotateX(0);
      }
    }
    
    @keyframes float {
      0% {
        transform: translateY(0) rotateZ(0);
      }
      50% {
        transform: translateY(-15px) rotateZ(2deg);
      }
      100% {
        transform: translateY(0) rotateZ(0);
      }
    }
    
    @keyframes pulse {
      0% {
        transform: scale(1);
        filter: brightness(1);
      }
      50% {
        transform: scale(1.05);
        filter: brightness(1.1);
      }
      100% {
        transform: scale(1);
        filter: brightness(1);
      }
    }
    
    @keyframes textReveal {
      0% { 
        opacity: 0;
        transform: scale(1.2);
        filter: blur(10px);
      }
      100% { 
        opacity: 1;
        transform: scale(1);
        filter: blur(0);
      }
    }
    
    @keyframes letterFloat {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-8px);
      }
    }
    
    @keyframes fadeInUp {
      0% { 
        opacity: 0;
        transform: translateY(40px);
      }
      100% { 
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes orbReveal {
      0% { opacity: 0; transform: scale(0.8); }
      100% { opacity: 1; transform: scale(1); }
    }
    
    @keyframes orbFloat {
      0% {
        transform: translatey(0px) translateX(0px);
      }
      33% {
        transform: translatey(-40px) translateX(20px);
      }
      66% {
        transform: translatey(20px) translateX(-20px);
      }
      100% {
        transform: translatey(0px) translateX(0px);
      }
    }
    
    @keyframes shineEffect {
      0% { transform: translateX(-100%) rotate(45deg); }
      100% { transform: translateX(200%) rotate(45deg); }
    }
    
    @keyframes btnShine {
      0% { transform: translateX(-100%) rotate(45deg); }
      100% { transform: translateX(200%) rotate(45deg); }
    }
    
    @keyframes particleFloat {
      0% {
        transform: translateY(0) translateX(0);
        opacity: 0;
      }
      10% {
        opacity: 1;
      }
      90% {
        opacity: 1;
      }
      100% {
        transform: translateY(-100vh) translateX(100px);
        opacity: 0;
      }
    }
  `;

  const [btnHovered, setBtnHovered] = useState(false);

  return (
    <div style={styles.body}>
      <style>{keyframes}</style>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
      `}</style>
      
      <div style={styles.particles}>
        {particleElements.map((particle) => (
          <div 
            key={particle.id} 
            style={styles.particle(particle)} 
          />
        ))}
      </div>
      
      <div style={{...styles.orb, ...styles.orb1, ...styles.orb(0, 0.2)}} />
      <div style={{...styles.orb, ...styles.orb2, ...styles.orb(1, 0.4)}} />
      <div style={{...styles.orb, ...styles.orb3, ...styles.orb(2, 0.6)}} />
      <div style={{...styles.orb, ...styles.orb4, ...styles.orb(3, 0.8)}} />
      
      <div style={styles.container}>
        <div style={styles.logo}>
          <div style={styles.logoWrapper}>
            <img 
              src={logoUrl} 
              alt="Alchemy Markets Logo" 
              style={styles.logoImage}
            />
          </div>
        </div>
        
        <h1 style={styles.heading}>
          {"COMING SOON".split('').map((letter, index) => (
            <span key={index} style={styles.headingSpan(index)}>
              {letter}
            </span>
          ))}
        </h1>
        
        <p style={styles.paragraph}>
          Exciting things are on their way. Stay tuned!
        </p>
        
        <button 
          style={{
            ...styles.notifyBtn,
            ...(btnHovered ? styles.notifyBtnHover : {})
          }}
          onMouseEnter={() => setBtnHovered(true)}
          onMouseLeave={() => setBtnHovered(false)}
          onClick={handleNotifyClick}
        >
          <div style={styles.notifyBtnBefore} />
          Notify Me
        </button>
      </div>
    </div>
  );
};

export default Comingsoon;